import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Menu, MenuItem, styled } from "@mui/material";
import React, { useRef, useState } from "react";
import { v4 as uuid } from "uuid";
import { Button } from "../Button/Button";
const comboShadowOverrideClass = `comboShadowOverride`;
const StyledDiv = styled("div")(() => ({
    [`& .${comboShadowOverrideClass}`]: {
        boxShadow: `0px 5px 5px -3px rgba(0,0,0,0.1),0px 8px 10px 1px rgba(0,0,0,0.08),0px 3px 14px 2px rgba(0,0,0,0.06)`
    }
}));
export function ComboBox(props) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [expanded, setExpanded] = useState(false);
    const muiButtonRef = useRef(null);
    const { id, className, style, items, onItemSelected, ...buttonProps } = props;
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setExpanded(true);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setExpanded(false);
    };
    const buttonWidth = muiButtonRef.current?.getBoundingClientRect().width;
    const menuItems = items.map((i) => {
        return (React.createElement(MenuItem, { key: i.displayName, onClick: () => {
                handleClose();
                onItemSelected(i);
            }, style: { minWidth: buttonWidth } }, i.displayName));
    });
    const expandIcon = expanded ? React.createElement(ExpandLessIcon, { fontSize: buttonProps.size }) : React.createElement(ExpandMoreIcon, { fontSize: buttonProps.size });
    //Giving these a guid so an id always exists for testing purposes.
    const buttonId = id ? `${id}-combobutton` : `${uuid()}-combobutton`;
    const menuId = id ? `${id}-combomenu` : `${uuid()}-combomenu`;
    const isOpen = Boolean(anchorEl);
    return (React.createElement(StyledDiv, { id: id, className: className, style: style },
        React.createElement(Button, { id: buttonId, "aria-controls": menuId, "aria-haspopup": true, "aria-expanded": isOpen, endIcon: expandIcon, onClick: handleClick, muiButtonRef: muiButtonRef, showActiveState: isOpen, ...buttonProps }),
        React.createElement(Menu, { id: menuId, "aria-labelledby": buttonId, anchorEl: anchorEl, keepMounted: true, open: isOpen, onClose: handleClose, anchorOrigin: { vertical: "bottom", horizontal: "left" }, transformOrigin: {
                vertical: "top",
                horizontal: "left"
            }, classes: { paper: comboShadowOverrideClass } }, menuItems)));
}
//Prop defaults.
ComboBox.defaultProps = {
    disabled: false,
    rounded: false,
    variant: "contained",
    color: "primary",
    text: "",
    size: "small"
};
